import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// 全局样式
import datav from "@jiaminghi/data-view";
// 引入echarts配置全局
import * as echarts from "echarts";
import "echarts-liquidfill/dist/echarts-liquidfill.min.js";
import 'echarts-gl'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueAnimateNumber from 'vue-animate-number';
import backgroundMusic from '@/assets/video/bgm.mp3'
 // key1: cd67af5d42e4c17b7268cf5ff11cb7a8   key2: f3c499be7a10009e9b41ca0c128b49fe
let mapKey ="f3c499be7a10009e9b41ca0c128b49fe";
Vue.prototype.mapKey = mapKey;
Vue.prototype.$playBackgroundMusic = function() {
  const audio = new Audio(backgroundMusic);
  audio.loop = true;
  audio.play();
};

// 艺展秘钥：cd67af5d42e4c17b7268cf5ff11cb7a8

// 创建一个全局指令 'v-click-sound'
Vue.directive('click-sound', {
  bind(el) {
    const audio = new Audio(require('@/assets/video/click.mp3')); // 路径根据你的项目结构调整
 
    el.addEventListener('click', () => {
      audio.play();
    });
  },
});

Vue.use(datav);
Vue.use(ElementUI);
Vue.use(VueAnimateNumber)

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
new Vue({
  router,
  store,
  render: (h) => h(App),
  created() {
    document.title = '数智招商·云上龙文';
  }
}).$mount("#app");
